<template>
  <div
    class="ag-dropzone py-5 px-12 text-center"
    :class="{ 'ag-dropzone-dragover': hasFileDragover }"
    @dragenter.prevent="hasFileDragover = true"
    @dragover.prevent
    @dragleave="hasFileDragover = false"
    @drop.prevent.stop="dropFile"
    @click="browseFile"
  >
    <slot />
    <input
      ref="input"
      type="file"
      class="d-none"
      @change="readFile"
    >
  </div>
</template>

<script>
export default {
  name: 'AgDropzone',
  data: () => ({
    hasFileDragover: false,
  }),
  methods: {
    browseFile () {
      this.$refs.input.click()
    },
    readFile (event) {
      this.$emit('upload', event.target.files[0])
      this.$refs.input.value = ''
    },
    dropFile ({ dataTransfer: { files: [file] } }) {
      this.hasFileDragover = false
      this.$emit('upload', file)
    },
  },
}
</script>

<style lang="scss" scoped>
.ag-dropzone {
  cursor: pointer;
  border-radius: 5px;
  border: 3px dashed #EEE;
}

.ag-dropzone-dragover {
  border: 3px dashed #DDD;
  background-color: #EEE;
}
</style>
